/** @jsx jsx */
import { jsx, Flex, Text, Box } from 'theme-ui'
import { Input, Form, Button } from 'antd'
import { AiOutlineDelete } from 'react-icons/ai'
import { PlusOutlined } from '@ant-design/icons'
import L from 'lodash'
import { SLACK_WEBHOOK_URL_REGEX } from '@spectral/types'

export const OrgTeamSlackIntegration = () => {
  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <Box sx={{ mb: '20px' }}>
        <Text sx={{ fontWeight: 600 }}>Creating a Slack webhook</Text>
        <Text>1. Create a Slack app</Text>
        <Text>2. Enable incoming webhooks</Text>
        <Text>3. Copy your webhook URL here</Text>
        <Text sx={{ mt: '10px' }}>
          For more information visit{' '}
          <a
            href="https://api.slack.com/messaging/webhooks"
            rel="noopener noreferrer"
            target="_blank"
          >
            the Slack docs
          </a>
        </Text>
      </Box>
      <Form.List
        name="slackWebhookUrl"
        rules={[
          {
            validator: async (_, slackWebhookUrls) => {
              if (slackWebhookUrls) {
                const webhooksValues = L.without(
                  slackWebhookUrls,
                  '',
                  undefined
                )
                const uniqWebhooks = L.uniq(webhooksValues)
                if (uniqWebhooks.length !== webhooksValues.length)
                  return Promise.reject(
                    new Error('This webhook is already attached to the team')
                  )
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Form.ErrorList errors={errors} />
            {fields.map((field, index) => (
              <Form.Item
                label={index === 0 ? 'Webhook URLs' : ''}
                key={field.key}
                sx={{ mb: 1 }}
              >
                <Flex>
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      {
                        required: true,
                        message: 'Slack webhook url is required',
                      },
                      {
                        pattern: new RegExp(SLACK_WEBHOOK_URL_REGEX),
                        message: 'Please enter a valid Slack webhook url',
                      },
                    ]}
                    sx={{ flexGrow: 1 }}
                  >
                    <Input placeholder="Please enter Slack webhook url" />
                  </Form.Item>
                  <AiOutlineDelete
                    sx={{
                      cursor: 'pointer',
                      ml: '10px',
                      alignSelf: 'flex-start',
                      minHeight: '40px',
                    }}
                    onClick={() => remove(field.name)}
                  />
                </Flex>
              </Form.Item>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add Webhook
              </Button>
            </Form.Item>
          </Box>
        )}
      </Form.List>
    </Flex>
  )
}
